<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M29.12 5.93a1.46 1.46 0 00-1.54-.68L3.75 9.64A1.49 1.49 0 003 12.17l4.67 4.68v5.94a1.49 1.49 0 00.93 1.38 1.47 1.47 0 00.58.12 1.49 1.49 0 001.06-.44l2.21-2.22 2.46 2.46a1.5 1.5 0 001.06.44h.11a1.47 1.47 0 001.1-.61L29.07 7.61a1.49 1.49 0 00.05-1.68zm-3.18 1.66L9.15 15.53l-4.1-4.1zm-16.3 14v-2.74L11 20.22zm6.24.68l-6-6 15.84-7.48z"/></svg>